import { Box, SxProps, Theme } from "@mui/material";
import icons from "enums/icons";
import theme from "assets/styles/themes";
import CustomIcon from "components/CustomIcon";

const defaultStyles: SxProps<Theme> = {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(2, 3),
    height: 68,
    width: 367,
    borderRadius: 22,
    backgroundColor: theme.palette.common.white,
    boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.16)",
    border: "unset",
    "&:hover": {
        cursor: "pointer",
    },
};

type TCardButtonProps = {
    children: React.ReactNode;
    onClick: () => void;
    icon?: typeof icons[keyof typeof icons];
    sx?: SxProps<Theme>;
};

const CardButton = ({ children, onClick, icon, sx }: TCardButtonProps): JSX.Element => {
    return (
        <Box component="button" onClick={onClick} sx={{ ...defaultStyles, ...sx }}>
            {icon && <CustomIcon icon={icon} sx={{ fontSize: "14px", marginRight: "8px" }} />}
            {children}
        </Box>
    );
};

export default CardButton;
